import Box from '@mui/material/Box';

import { brand } from '../theme';

/**
 * Cheddar mark + wordmark. Clear space on all sides is 30% of the mark height;
 * minimum mark size on screen is 22px, so `size` should never go below that.
 */
export default function Brand({
  size = 30,
  showWordmark = true,
}: {
  size?: number;
  showWordmark?: boolean;
}) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: `${size / 3}px` }}>
      <Box
        component="img"
        src="/logo-single.svg"
        alt="Cheddar"
        sx={{ width: size, height: size, display: 'block' }}
      />
      {showWordmark ? (
        <Box
          component="span"
          sx={{
            fontSize: size * 0.63,
            fontWeight: 800,
            letterSpacing: '-0.035em',
            color: brand.ink,
          }}
        >
          Cheddar
        </Box>
      ) : null}
    </Box>
  );
}

/** Address / hash text — JetBrains Mono, always. */
export function MonoText({
  children,
  size = 13,
  sx,
}: {
  children: React.ReactNode;
  size?: number;
  sx?: object;
}) {
  return (
    <Box
      component="code"
      sx={{
        fontFamily: brand.mono,
        fontSize: size,
        lineHeight: 1.45,
        wordBreak: 'break-all',
        color: brand.body,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
